import React from 'react'
//Bibliotecas
import styled from 'styled-components'

function ProgressBar({ value, max, color, width }) {
    return (
        <Wrapper color={color} width={width}>
            <progress value={value} max={max}></progress>
            <span>{value}% completo</span>
        </Wrapper>
    )
}

export default ProgressBar

const Wrapper = styled.div` 
    box-sizing:border-box;
    width:100%;
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    margin:16px;
    span{
        font-weight:700;
    }

    progress {
        box-sizing:border-box;
        width:${props=> props.width ? props.width : '100%'};
        border-radius: 10px; 
        height: 32px;
        margin-right:16px;
        border: 1px solid  rgba(0,0,0,.1);
    }
    progress::-webkit-progress-bar {
        background-color: var(--color-gris-claro);
        border-radius: 10px;
    }
    progress::-webkit-progress-value {
        background-color: var(--color-morado-claro);
        border-radius: 10px;
    }
`;

